import React from 'react';
import { LanguageString } from '../../Common';
import {
  TableCell,
  TableRow,
  Typography,
  IconButton,
  Icon
} from '@material-ui/core';
import * as DTO from '../../../dto';
import { MTSContextProps } from '../../../contexts';
import { useClasses } from '../../../hooks';

interface CalendarCustomReportingRowProps {
  activities: DTO.MTSActivity[] | undefined;
  mtsCtx: MTSContextProps;
  setAddModalOpen: (open: boolean) => void;
  setReadonlyMode: (readonlyMode: boolean) => void;
  setActiveMTSEntry: (activeMTSEntry: DTO.MTSActivity | undefined) => void;
  setDeleteModalOpen: (deleteModalOpen: boolean) => void;
}

export const CalendarCustomReportingRow: React.FC<CalendarCustomReportingRowProps> = ({ activities, mtsCtx, setAddModalOpen, setReadonlyMode, setActiveMTSEntry, setDeleteModalOpen }) => {
  const classes = useClasses();

  const deleteButtonPressed = (entry: DTO.MTSActivity) => {
    setActiveMTSEntry(entry);
    setDeleteModalOpen(true);
  };

  const totalHours = () => {
    let total = 0;
    if (activities) {
      for (const activity of activities) {
        total += activity.hours;
      }
    }

    return total;
  };

  return (
    <>
      {activities && activities.length > 0 ? (
        <>
          {activities.map(mts => (
            <TableRow key={`mts_activity_${mts.id}`}>
            <TableCell>
              <Typography style={{ fontStyle: mts.userType?.expiring === true ? 'italic' : 'normal' }}>
                <LanguageString languageString={mts.userType?.name ?? mts.type.name} />
              </Typography>
            </TableCell>
            <TableCell>{mts.hours}</TableCell>
            <TableCell>{mts.lastEditedBy ? mts.lastEditedBy.firstName + ' ' + mts.lastEditedBy.lastName : ''}</TableCell>
            <TableCell align="right">
              <IconButton
                role="button"
                aria-label="view"
                onClick={() => {
                  setReadonlyMode(true);
                  setActiveMTSEntry(mts);
                  setAddModalOpen(true);
                }}
              >
                <Icon>visibility_outlined</Icon>
              </IconButton>
              {mtsCtx.canChangeSelectedMTS && (
                <IconButton
                  role="button"
                  aria-label="edit"
                  onClick={() => {
                    setActiveMTSEntry(mts);
                    setAddModalOpen(true);
                  }}
                >
                  <Icon>edit</Icon>
                </IconButton>
              )}
              {mtsCtx.canChangeSelectedMTS && (
                <IconButton
                  role="button"
                  aria-label="delete"
                  onClick={() => {
                    deleteButtonPressed(mts);
                  }}
                >
                  <Icon>delete</Icon>
                </IconButton>
              )}
            </TableCell>
          </TableRow>
          ))}
          <TableRow key={`mts_total_row`}>
            <TableCell className={classes.bold}>
              <LanguageString groupName="MTS" resourceName="MTS_TOTAL_HOURS" defaultText="Total" />
            </TableCell>
            <TableCell className={classes.bold}>{totalHours()}</TableCell>
            <TableCell />
            <TableCell />
          </TableRow>
        </>
      ) : (
        <div>No activities</div>
      )}
    </>
  );
};
